import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=425bf4b4&"
import script from "./TheHeader.vue?vue&type=script&lang=ts&"
export * from "./TheHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports